import { EStoreExecutorTable, ID } from '@project/shared-types';

export const getWorkImageUrl = (image: string, jobId?: ID) => {
    if (image.includes('jobs')) {
        return jobId ? `/${image}` : image;
    }
    if (jobId) {
        return `/media/content/${EStoreExecutorTable.WORKS}/${jobId}/${image}`;
    }
    return `/media/content/${EStoreExecutorTable.WORKS}/${image}`;
};
